module.exports = __webpack_public_path__ + "img/20.3f83a940.jpg";